import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { setCurrentPage } from '@courseResume/store/coursePauseRequest';
import Pagination from 'components/Pagination';
import styles from './CoursePauseRequestPagination.module.scss';

function CoursePauseRequestPagination({ pageCount, currentPage }) {
  const dispatch = useDispatch();

  const handlePageChange = useCallback(
    (event) => {
      dispatch(setCurrentPage(event.selected + 1));
    },
    [dispatch]
  );

  return (
    <Pagination
      onPageChange={handlePageChange}
      pageCount={pageCount}
      forcePage={currentPage - 1}
      className={styles.paginate}
    />
  );
}

export default CoursePauseRequestPagination;
